import '@/assets/styles/reset.scss'
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from '@/router/index'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@/assets/styles/tailwind.css'
import 'element-plus/dist/index.css'
import '@/assets/styles/main.scss'
import CamIcons from '@/components/CamIcons'
import 'virtual:svg-icons-register'
import './utils/fiexible.js'
const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(ElementPlus)
app.component('CamIcons', CamIcons)

// 全局注册ElementPlus图标
for (const [
  key,
  component,
] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
import premissionDev from '@/utils/premissionDev.js'
import premission from '@/utils/premission.js'

if (import.meta.env.VITE_APP_ENV === 'development') {
  premissionDev()
} else {
  premission()
}

app.mount('#app')
